import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';

import { store, persistor } from './store/store';
import App from './_app';
import SessionProvider from './components/SessionProvider';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    {/* PersistGate only runs on the client */}
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
